// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Youtube: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 36 36">
            <g fill="none" fillRule="evenodd">
                <circle cx="18" cy="18" r="17.5" stroke="currentColor" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M27.582 13.19a2.507 2.507 0 0 0-1.768-1.771C24.254 11 18 11 18 11s-6.254 0-7.814.419c-.86.23-1.538.91-1.768 1.772C8 14.753 8 18.014 8 18.014s0 3.26.418 4.824a2.47 2.47 0 0 0 1.768 1.743C11.746 25 18 25 18 25s6.254 0 7.814-.419a2.47 2.47 0 0 0 1.768-1.743C28 21.275 28 18.014 28 18.014s0-3.26-.418-4.823zm-11.627 7.785v-5.921l5.227 2.96-5.227 2.96z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Youtube);
